import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EcomHttpClient } from '@wix/wixstores-client-storefront-sdk';
import { CheckoutSettingsApi } from '../apis/CheckoutSettingsApi';
import { ECOM_PLATFORM_APP_DEF_ID } from '../../utils/consts';
const origin = 'express-checkout';
export class CheckoutSettingsService {
  constructor(controllerConfig) {
    _defineProperty(this, "checkoutSettingsApi", void 0);
    _defineProperty(this, "wixCodeApi", void 0);
    _defineProperty(this, "isInEditorMode", void 0);
    const siteStore = new EcomHttpClient({
      wixCodeApi: controllerConfig.wixCodeApi,
      instance: controllerConfig.appParams.instance,
      storeId: controllerConfig.appParams.instanceId,
      csrfToken: controllerConfig.csrfToken,
      essentials: controllerConfig.essentials,
      isSSR: controllerConfig.wixCodeApi.window.rendering.env === 'backend',
      experiments: controllerConfig.essentials.experiments
    });
    this.wixCodeApi = controllerConfig.wixCodeApi;
    this.checkoutSettingsApi = new CheckoutSettingsApi({
      siteStore,
      origin
    });
    controllerConfig.wixCodeApi.site.onInstanceChanged(_ref => {
      let {
        instance
      } = _ref;
      siteStore.instanceManager.setInstance(instance);
    }, ECOM_PLATFORM_APP_DEF_ID);
    this.isInEditorMode = controllerConfig.wixCodeApi.window.viewMode === 'Editor';
  }
  async getSiteSettings() {
    return this.checkoutSettingsApi.getCheckoutSettings();
  }
  async getExpressCheckoutSettings() {
    try {
      const api = await this.wixCodeApi.site.getPublicAPI(ECOM_PLATFORM_APP_DEF_ID);
      return api.__internal.expressCheckout.settings();
    } catch (error) {
      if (this.isInEditorMode) {
        return {
          isExpressSupported: true,
          taxOnProduct: false,
          hasPolicies: false,
          requirePolicyAgreement: false
        };
      }
      throw error;
    }
  }
}
//# sourceMappingURL=CheckoutSettingsService.js.map